module.exports = __webpack_public_path__ + "media/images/empty/notification-a9ffffaa9a0428a5d512822a076bf2cf.svg";